import React from "react";
import bell from "../../assets/icons/bell.svg";
import pen from "../../assets/icons/pen.svg";
import pallet from "../../assets/icons/pallet.svg";
import FeatureCard from "./FeatureCard/FeatureCard";
import "./MoreFeatures.css";
import {TranslationsMap} from "../../pages/CountryPage/CountryPage";

interface MoreFeaturesProps {
  translations: TranslationsMap
}

const MoreFeatures: React.FC<MoreFeaturesProps> = ({translations}) => {
  return (
    <div className="more-features-container">
      <h1 className="more-features-header">{translations["landingPage.moreFeatures.title"]}</h1>
      <div className="feature-cards-container">
        <FeatureCard
          color="#FEE5D3"
          iconSrc={pen}
          label={translations["landingPage.moreFeatures.feel.title"]}
          body={translations["landingPage.moreFeatures.feel.body"]}/>
        <FeatureCard
          color="#E5E9FE"
          iconSrc={pallet}
          label={translations["landingPage.moreFeatures.discover.title"]}
          body={translations["landingPage.moreFeatures.discover.body"]}/>
        <FeatureCard
          color="#D9F5CB"
          iconSrc={bell}
          label={translations["landingPage.moreFeatures.tools.title"]}
          body={translations["landingPage.moreFeatures.tools.body"]}/>
      </div>
    </div>
  );
}

export default MoreFeatures;